import { render } from "./UniversityCards.vue?vue&type=template&id=7921ec5a"
import script from "./UniversityCards.vue?vue&type=script&lang=js"
export * from "./UniversityCards.vue?vue&type=script&lang=js"

import "./UniversityCards.vue?vue&type=style&index=0&id=7921ec5a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__